import { submitPartnerRef } from './api';
import { clearPartnerRef, getPartnerRef } from './partnerRef';

/**
 * Nachtragen der Partner-Ref für bestehende/eingeloggte User (Spec §2).
 * Wird fire-and-forget aus fetchCurrentUser (user.duck) aufgerufen.
 * - User hat schon eine Zuordnung -> localStorage löschen, kein POST (first-wins)
 * - Server antwortet 4xx -> localStorage löschen (kein Retry-Loop)
 * - transienter Fehler (5xx/Netzwerk) -> Eintrag behalten, nächster Login versucht es erneut
 * @param {object} currentUser - denormalisierter currentUser inkl. privateData
 * @returns {Promise<'none'|'already-assigned'|'synced'|'rejected'|'error'>}
 */
export const syncPartnerRefToUser = async (currentUser) => {
  const ref = getPartnerRef();
  if (!ref) return 'none';
  const existingPartner = currentUser?.attributes?.profile?.privateData?.partnerName;
  if (existingPartner) {
    clearPartnerRef();
    return 'already-assigned';
  }
  try {
    await submitPartnerRef(ref);
    clearPartnerRef();
    return 'synced';
  } catch (e) {
    // Jedes 4xx ist permanent für diesen Eintrag: 409 = schon zugeordnet,
    // 400 = die Ref ist ungültig/nicht auf der Allowlist, 401/403 = die Session
    // trägt nicht. Behielten wir den Eintrag, würde er bis zu 30 Tage lang bei
    // JEDEM fetchCurrentUser erneut gepostet. Nur 5xx/Netzwerkfehler sind
    // transient und einen späteren Versuch wert.
    const status = e && e.status;
    if (status >= 400 && status < 500) {
      clearPartnerRef();
      return 'rejected';
    }
    return 'error';
  }
};
